import * as knn from '@tensorflow-models/knn-classifier';

var classifier = function classifier() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : knn.create();
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    default:
      return state;
  }
};

export default classifier;